export const tableOption = {
  "border": true,
  "index": true,
  "stripe": true,
  "indexLabel": "序号",
  "menuAlign": "center",
  "align": "center",
  "editBtn": false,
  "delBtn": false,
  "addBtn": false,
  'refreshBtn': false,
  'columnBtn': false,
  'searchSize': 'mini',
  'searchBtn': false,
  "dic": [],
  "column": [
    {
      label: '',
      prop: 'id',
      hide: true,
      editVisdiplay: false,
      addVisdiplay: false
    },
    {
      label: '员工编号',
      prop: 'employeeId'
    },
    {
      label: '员工姓名',
      prop: 'employeeName'
    },
    {
      label: '员工部门',
      prop: 'employeeDept',
      type: 'tree'
    },
    {
      label: '所属公司',
      prop: 'companyCode',
      type: 'select'
    },
    {
      label: '手机',
      prop: 'phone'
    },
    {
      label: '电子邮件',
      prop: 'email'
    },
    {
      label: '状态',
      prop: 'status'
    }
  ]
}
